export const brandFAQs = {
  osm: [
    {
      id: 1,
      question: "What is the price of the OSM Stream electric auto in India?",
      answer:
        "The passenger-focused OSM Stream starts at an OSM auto price of approximately ₹3.40 Lakh (Ex-showroom).",
    },
    {
      id: 2,
      question: "What is the real-world range of the OSM electric auto on a single charge?",
      answer:
        "The OSM Rage Plus delivers a real-world range of approximately 95–110 km, depending on the load and driving conditions.",
    },
    {
      id: 3,
      question: "How long does it take to fully charge an Omega Seiki electric rickshaw?",
      answer:
        "A full charge using a standard AC charger takes about 3.5 to 4 hours.",
    },
    {
      id: 4,
      question: "Does the OSM electric auto require a driving license?",
      answer:
        "Yes, since OSM produces high-speed L5 category vehicles, a valid commercial driving license is mandatory.",
    },
    {
      id: 5,
      question: "What is the seating capacity of the OSM Stream?",
      answer:
        "The OSM Stream passenger variant typically seats a Driver + 3 passengers comfortably.",
    },
    {
      id: 6,
      question: "Which battery technology does Omega Seiki Mobility use?",
      answer:
        "OSM uses high-grade Lithium-ion (NMC or LFP) battery packs, often integrated with smart BMS (Battery Management Systems).",
    },
    {
      id: 7,
      question: "Is there a cargo version of the OSM electric vehicle?",
      answer:
        "Yes, the OSM Rage Plus is the primary cargo version, available in multiple deck configurations.",
    },
    {
      id: 8,
      question: "How does the OSM Stream compare to the Mahindra Treo?",
      answer:
        "While both are reliable, the OSM Stream is often noted for its more rugged steel body and higher peak torque for climbing slopes.",
    },
    {
      id: 9,
      question: "What is the payload capacity of the OSM Rage+ electric loader?",
      answer:
        "The standard OSM Rage Plus has a payload capacity of 500 kg, while the 10.8 kWh variant handles up to 550 kg.",
    },
    {
      id: 10,
      question: "What warranty does Omega Seiki offer on its electric autos?",
      answer:
        "Omega Seiki typically offers a 3-year or 80,000 km warranty on the battery and the vehicle powertrain.",
    },
  ],
  piaggio: [
    {
      id: 1,
      question: "Which country brand is Piaggio Auto?",
      answer:
        "Piaggio is originally an Italy brand that became world-famous due to its spectacular designs and engineering.",
    },
    {
      id: 2,
      question: "Is Piaggio an Indian company?",
      answer:
        "Piaggio is originally an Italian brand. Piaggio Vehicles Pvt Ltd (PVPL) is an Indian subsidiary with its manufacturing hub in Baramati, Maharashtra.",
    },
    {
      id: 3,
      question: "What is the price of Piaggio in India?",
      answer:
        "The ape auto price for electric models starts from approximately ₹2.85 Lakh and goes up based on the model and battery capacity.",
    },
    {
      id: 4,
      question: "What is the mileage of Piaggio electric auto?",
      answer:
        'Electric autos provide a "range" rather than mileage. Depending on the model, you can expect between 110 km to 150 km per full charge.',
    },
    {
      id: 5,
      question: "What are the disadvantages of using CNG auto?",
      answer:
        "CNG autos face long queues at filling stations, rising fuel prices, higher vibration levels, and higher periodic maintenance costs compared to electric versions.",
    },
    {
      id: 6,
      question: "What is the range of Piaggio Electric Auto?",
      answer:
        "The standard FX models offer about 110 km, while the new FX Max series offers up to 150 km of certified range.",
    },
    {
      id: 7,
      question: "How long does charging take for Piaggio Electric Auto?",
      answer:
        "A full charge typically takes 3.5 to 4 hours using a standard AC charger.",
    },
    {
      id: 8,
      question: "What is the warranty of Piaggio Electric Autos?",
      answer:
        "Piaggio typically offers a 3-year or 80,000 km warranty (whichever is earlier) on the battery and the vehicle.",
    },
    {
      id: 9,
      question: "Can the batteries be swapped?",
      answer:
        "While Piaggio has fixed battery models (FX), they also offer swappable battery variants in partnership with battery-swapping networks.",
    },
    {
      id: 10,
      question: "What is the battery life of Piaggio electric auto?",
      answer:
        "The advanced Lithium-ion batteries used by Piaggio are designed to last for 3,000+ charging cycles, usually spanning 5 to 7 years depending on usage.",
    },
  ],
  euler: [
    {
      id: 1,
      question: "What is the current Euler EV price range in India for 2026?",
      answer:
        "The Euler EV price for 2026 starts from ₹ 4.14 Lakh for the Euler HiLoad DV (130 Cu. Ft) and HiLoad PV models, going up to ₹ 9.10 Lakh for the high-capacity Euler Storm EV (Ex-showroom). This wide Euler Motor price list ensures there is a vehicle for every business scale. At Turno, we offer the most transparent pricing and exclusive Turno Euler offers to ensure you get the best ROI.",
    },
    {
      id: 2,
      question: "Where can I find an Euler HiLoad EV showroom near me?",
      answer:
        "You don't need to spend hours searching for a physical Euler hiload ev showroom near me. You can browse and book the entire Euler Motors lineup through Turno, your trusted digital Euler EV dealership near me. We provide doorstep test drives, expert consultations, and end-to-end delivery across major cities.",
    },
    {
      id: 3,
      question: "What is the real-world range of the Euler electric auto?",
      answer:
        "The Euler electric auto is designed for maximum uptime. The Euler HiLoad DV and PV variants offer a reliable max range of 120 km, while the heavy-duty Euler Storm EV delivers up to 140 km on a single charge. This ensures your Euler tempo can handle long delivery routes without the need for midday charging.",
    },
    {
      id: 4,
      question: "How much load can the Euler Hiload EV and Storm EV carry?",
      answer:
        "The Euler Hiload EV series (DV and PV) is built for a payload capacity of 688 kg, making it perfect for standard e-commerce and retail deliveries. For businesses with heavier requirements, the Euler Storm EV offers a massive 1250 kg payload capacity, outperforming almost every other Euler electric 3 wheeler in its class.",
    },
    {
      id: 5,
      question: "How does the liquid-cooled battery in the Euler three wheeler help?",
      answer:
        "The Euler HiLoad EV features India's first liquid-cooled battery technology in a three-wheeler. This system prevents the battery from overheating during fast-charging or heavy-duty operations in hot summer season. It significantly improves battery life and ensures the Euler electric 3 wheeler remains the safest and most reliable Euler electric commercial vehicle on the market.",
    },
    {
      id: 6,
      question: "Does Turno provide financing for the Euler electric commercial vehicle?",
      answer:
        "Absolutely! We offer tailored financing solutions for the entire Euler electric commercial vehicle range. Whether you are eyeing the Euler hiload ev price of ₹ 4.14 Lakh or the premium Euler Storm EV, Turno provides low-interest loans and quick approvals. Plus, our Guaranteed Buyback program protects your vehicle's future resale value.",
    },
    {
      id: 7,
      question: "How long does it take to charge an Euler electric tempo?",
      answer:
        "The Euler tempo is manufactured for speed because all business needs it. With rapid charging technology, you can get a significant range boost in just a few minutes. Typically, a full charge for an Euler three wheeler takes between 3.5 to 4 hours on a standard charger, allowing for efficient overnight charging so your vehicle is ready for a full day of work every morning.",
    },
  ],
  hindiEular: [
    {
      id: 1,
      question: "क्या मुझे Euler Hiload EV की कीमत पर कोई ऑफ़र और छूट मिल सकती है?",
      answer:
        "Turno में, हम खरीद ने के राज्य हिसाब से ऑफ़र और छूट देते हैं। आपके अपने राज्य में Euler लोडर की कीमतों पर चल रहे ऑफ़र जानने के लिए कृपया हमसे 08047482233 पर संपर्क करें।",
    },
    {
      id: 2,
      question:
        "क्या मुझे यूलर मोटर्स की मूल्य सूची मिल सकती है?",
      answer:
        "Euler HiLoad कई वैरिएंट में आता है, और कीमत आपके द्वारा चुने गए मॉडल पर निर्भर करती है। कीमत ₹ 4.26 लाख - ₹ 4.46 लाख के बीच हो सकती है। अपने राज्य में यूलर लोडर की कीमतों पर चल रहे ऑफ़र जानने के लिए कृपया हमसे 08047482233 पर संपर्क करें।",
    },
    {
      id: 3,
      question: "Euler Electric गाड़ियों के प्रकार कौन-कौन से हैं?",
      answer:
        "उत्तर: Euler विभिन्न प्रकार की इलेक्ट्रिक वाणिज्यिक गाड़ियाँ पेश करता है, जिनमें दो मॉडल की इलेक्ट्रिक ऑटो शामिल हैं - HiLoad PV और HiLoad DV।",
    },
    {
      id: 4,
      question: " Euler Electric गाड़ी खरीदने के क्या क्या फायदे हैं?",
      answer:
        "उत्तर: Euler कार्गो इलेक्ट्रिक ऑटो के मालिक होने के फायदे हैं: उन्नत तकनीक, सबसे सुरक्षित बैटरी, विश्वसनीय प्रदर्शन, गाड़ियों की विविधता, और किफायती संचालन।",
    },
    {
      id: 5,
      question: "Euler Electric तिपहिया गाड़ी कहाँ खरीदें?",
      answer:
        "उत्तर: Euler इलेक्ट्रिक गाड़ी खरीदने के लिए Turno सबसे अच्छा स्थान है। Turno के पारंपरिक खरीद विकल्पों पर कई फायदे हैं।",
    },
    {
      id: 6,
      question: "Euler Electric गाड़ी कितनी जल्दी चार्ज होती है?",
      answer: "उत्तर: Euler थ्री व्हीलर ऑटो 15 मिनट में 50 किलोमीटर के लिए चार्ज हो सकती है।",
    },
    {
      id: 7,
      question: "Euler 3 Wheeler किस तरह की रखरखाव की आवश्यकता हैं?",
      answer:
        "उत्तर: Euler इलेक्ट्रिक गाड़ियों को कम रखरखाव की आवश्यकता होती है, जैसे टायर रोटेशन, ब्रेक निरीक्षण, बैटरी निरीक्षण, और सामान्य निरीक्षण।",
    },
  ],
  mahindra: [
    {
      id: 1,
      question: "What is the current price of Mahindra electric autos in India?",
      answer:
        "The Mahindra electric auto price starts from ₹1.61 Lakh for the e-Alfa Super and goes up to over ₹4.10 Lakh for the high-end Zor Grand cargo model.",
    },
    {
      id: 2,
      question: "How do ex-showroom and on-road prices differ?",
      answer:
        "The ex-showroom price is the base cost, while the Mahindra electric auto on road price includes RTO registration, insurance, and state-specific subsidies like FAME-II or EMPS 2024.",
    },
    {
      id: 3,
      question: "Are there subsidies available for Mahindra electric autos?",
      answer:
        "Yes, most Mahindra EVs are eligible for the Electric Mobility Promotion Scheme (EMPS) 2024 and various state-level incentives that can reduce the price by ₹25,000 to ₹50,000.",
    },
    {
      id: 4,
      question: "What is the typical EMI for a Mahindra electric auto?",
      answer:
        "Through Turno, EMI for a Mahindra electric auto can start as low as ₹10,229 per month, depending on your down payment and tenure.",
    },
    {
      id: 5,
      question: "What is the total cost of ownership (TCO) compared to CNG?",
      answer:
        "A Mahindra electric auto can save you up to ₹6,00,000 over 5 years in fuel and maintenance costs compared to a CNG auto, with a running cost of just 40–50 paise per km.",
    },
    {
      id: 6,
      question: "Which is the cheapest Mahindra electric auto in India?",
      answer:
        "The Mahindra e-Alfa Super (often called the Mahindra toto) is the most affordable model, starting at approximately ₹1.61 Lakh (ex-showroom).",
    },
    {
      id: 7,
      question: "How do I get a Mahindra electric auto loan in India?",
      answer:
        "You can apply directly through Turno. We provide specialized EV financing with a 10.5% interest rate and assistance with all documentation.",
    },
  ],

  etrio: [
    {
      id: 1,
      question: "What is the price of Etrio in India?",
      answer:
        "The flagship Etrio Touro MAX++ starts at an ex-showroom price of ₹4.10 Lakh.",
    },
    {
      id: 2,
      question: "What is the mileage of Etrio electric auto?",
      answer:
        "As an electric vehicle, it offers a range of 100 km per full charge.",
    },
    {
      id: 3,
      question: "What is the range of Etrio Electric Auto?",
      answer:
        "The Touro MAX++ provides a certified range of 100 km, sufficient for most daily urban delivery cycles.",
    },
    {
      id: 4,
      question: "How long does it take to charge an Etrio 3-wheeler?",
      answer:
        "It typically takes about 4 to 5 hours for a full charge using a standard AC charger.",
    },
    {
      id: 5,
      question: "What is the warranty of Etrio Electric Autos?",
      answer:
        "Etrio generally offers a 3-year or 80,000 km warranty (whichever comes first) on the battery and motor.",
    },
    {
      id: 6,
      question: "Can the batteries be swapped?",
      answer:
        "Currently, Etrio focuses on fixed-battery technology for better stability, though they are exploring swapping for future variants.",
    },
    {
      id: 7,
      question: "What is the battery life of Etrio electric auto?",
      answer:
        "The Lithium-ion battery is designed to last between 1,500 to 2,000 charging cycles, roughly 5–7 years of usage.",
    },
    {
      id: 8,
      question: "What is the range of the Etrio Touro Max on a single charge?",
      answer:
        "The Touro Max++ delivers a consistent 100 km range on a single full charge under standard conditions.",
    },
    {
      id: 9,
      question: "Is Etrio an Indian company?",
      answer:
        "Yes, Etrio is a Hyderabad-based Indian EV manufacturer.",
    },
    {
      id: 10,
      question: "What is the payload capacity of the Etrio Touro?",
      answer:
        "The Touro MAX++ is rated for a 550 kg payload.",
    },
    {
      id: 11,
      question: "Does Etrio offer both cargo and passenger 3-wheelers?",
      answer:
        "Etrio currently focuses primarily on the cargo segment (Touro series) to serve the booming logistics industry.",
    },
  ],
  altigreen: [
    {
      id: 1,
      question: "What is Altigreen Electric Auto?",
      answer:
        "Altigreen Electric Auto is a smart and efficient electric cargo vehicle created by Altigreen Propulsion Labs. It's designed for last-mile deliveries, packed with advanced technology and practical features.",
    },
    {
      id: 2,
      question: "What makes Altigreen Electric Auto unique?",
      answer:
        "Altigreen Electric Auto stands out for its advanced engineering, featuring an impressive 11 kWh battery that provides a certified range of 150 km. Additionally, it incorporates regenerative braking to conserve energy efficiently.",
    },
    {
      id: 3,
      question: "How does Altigreen Electric Auto ensure efficiency?",
      answer:
        "Altigreen Electric Auto delivers strong performance with 8.25 kW peak power and 45 Nm peak motor torque. It has regenerative braking that charges the battery when slowing down, enhancing overall efficiency.",
    },
    {
      id: 4,
      question: "Can Altigreen Electric Auto go on tough roads?",
      answer:
        "Altigreen Electric Auto can go on rough roads easily with a top speed of 53 km/h and a 220 mm ground clearance. It moves effortlessly on difficult terrains and speedbreakers.",
    },
    {
      id: 5,
      question: "What is the running cost of Altigreen Electric Auto?",
      answer:
        "Altigreen Electric Auto offers an incredibly economical running cost of just ₹92 per 100 kilometres, providing significant savings over time.",
    },
    {
      id: 6,
      question:
        "How many days does Turno take to deliver Altigreen Electric Auto?",
      answer:
        "When you purchase Altigreen Electric Auto from Turno, your vehicle will be delivered to your doorstep in just 3 days.",
    },
    {
      id: 7,
      question: "What is the best use of an Altigreen Electric Auto?",
      answer:
        "Altigreen Electric Auto is an ideal solution for businesses engaged in delivery services, offering efficient, eco-friendly, and economical transportation options.",
    },
    {
      id: 8,
      question: "From where can I purchase Altigreen Electric Auto?",
      answer:
        "You can purchase Altigreen Electric Auto from Turno. At Turno, EV experts will give you the right information about the vehicle, a free test drive, the benefits of Altigreen Electric Auto for your business, and all the Turno benefits. Please reach out to Turno’s dedicated team or visit turno.club.",
    },
    {
      id: 9,
      question: "What is the warranty of Altigreen Electric Auto?",
      answer:
        "The Altigreen Electric auto comes with an extensive warranty. The vehicle warranty is for 3 years or 1 lakh km, whichever comes first.",
    },
  ],

  greaves: [
    {
      id: 1,
      question: "What are the variants of Greaves Eltra and Greaves ePro?",
      answer:
        "Greaves Eltra and Greaves ePro come in three variants i.e. pick-up, flatbed, and delivery van. These variants can also be customized as per the business requirements.",
    },
    {
      id: 2,
      question: "What sets Greaves Electric Vehicles apart?",
      answer:
        "Greaves Electric Vehicles stand out due to their cutting-edge technology, efficient battery systems, impressive performance, and eco-conscious design.",
    },
    {
      id: 3,
      question: "Are Greaves Electric Vehicles suitable for tough terrains?",
      answer:
        "Yes, Greaves Electric Vehicles are designed to navigate through diverse terrains with ease and confidence, making them suitable for various environments.",
    },
    {
      id: 4,
      question: "What is the operational cost of Greaves Electric Vehicles?",
      answer:
        "Greaves Electric Vehicles offer an economical running cost of ₹86 for 100 km, providing significant savings compared to traditional vehicles.",
    },
    {
      id: 5,
      question: "How can I purchase Greaves Electric Vehicles?",
      answer:
        "If you want to purchase a Greaves electric vehicle, please reach out to Turno experts or visit turno.club. Turno experts will assist you in vehicle selection, provide a free test drive, offer vehicle financing, arrange at-home vehicle delivery, manage annual servicing, and provide extended customer support.",
    },
    {
      id: 6,
      question:
        "Are Greaves Electric Vehicles eligible for government incentives or subsidies?",
      answer:
        "Yes, many government incentives and subsidies are available for Greaves Electric Vehicles as part of promoting eco-friendly transportation. You can check with the Turno experts for the exact amount.",
    },
    {
      id: 7,
      question: "What is the warranty coverage for Greaves Electric Vehicles?",
      answer:
        "Greaves Electric Vehicles typically come with a manufacturer's warranty of 3 Years/80,000 km.",
    },
    {
      id: 8,
      question:
        "Are there any public charging stations available for Greaves Electric Vehicles?",
      answer:
        "Yes, there is a growing network of public charging stations for Greaves Electric Vehicles. Greaves may also collaborate with charging station providers for wider access.",
    },
    {
      id: 9,
      question: "Does Turno offer loans for Greaves Electric Vehicles?",
      answer:
        "Yes, Turno provides loans for Greaves Electric Vehicles. You can call the Turno experts and inquire about the financing options for Greaves electric trucks.",
    },
  ],
};

export const vehicleFAQs = {
  treoZor: [
    {
      id: 1,
      question:
        "Can I schedule a test drive of the Mahindra Treo Zor at Turno?",
      answer:
        "Yes, you can. Once you book the electric gaadi on the website, a Turno expert will help you schedule a test drive.",
    },
    {
      id: 2,
      question:
        "What financing options are available for purchasing the Mahindra Treo Zor at Turno?",
      answer:
        "You can apply for your EV three-wheeler loan through the Turno website or app. In case you purchase from Turno, you will be eligible for an exclusive buy-back option too after three years for a maximum of up to ₹150,000.",
    },
    {
      id: 3,
      question:
        "Is the Mahindra Treo Zor suitable for city driving and congested areas?",
      answer:
        "Since the Mahindra Treo Zor is very compact, it can easily navigate all city streets as small as 3 meters wide.",
    },
    {
      id: 4,
      question:
        "Can I charge the Mahindra Treo Zor at home or do I need specialized charging stations?",
      answer:
        "You can charge the Mahindra Treo Zor from any normal 16 amp socket at home. Also, you can charge it at dedicated charging stations.",
    },
    {
      id: 5,
      question:
        "Are there any maintenance requirements specific to the Mahindra Treo Zor?",
      answer:
        "Since there is no engine in the Mahindra Treo Zor, there are no significant maintenance requirements for this EV. But regular servicing and check-ups should be done.",
    },
    {
      id: 6,
      question:
        "Does the Mahindra Treo Zor come with any connectivity features or smart technologies?",
      answer:
        "Yes, the Mahindra Treo Zor has an app where you can use geolocation and keep track of the vehicle and manage it from wherever you are.",
    },
    {
      id: 7,
      question:
        "Can I customize the Mahindra Treo Zor to suit my business needs?",
      answer:
        "Turno has partnered with best-selling commercial vehicles across India to cater to different needs. All you have to do is contact one of our experts, and they’ll tell you which EV fits your business.",
    },
    {
      id: 8,
      question:
        "Can I trade in my existing vehicle at Turno when purchasing the Mahindra Treo Zor?",
      answer:
        "Yes, you can exchange your existing vehicle for an electric auto.",
    },
    {
      id: 9,
      question:
        "What are the warranty terms and coverage for the Mahindra Treo Zor?",
      answer:
        "You get a 5-year warranty on the battery and a 3-year warranty on the EV itself.",
    },
    {
      id: 10,
      question: "What are the delivery timelines for the Mahindra Treo Zor?",
      answer:
        "It usually takes us 5 days to deliver the electric vehicle after the booking amount is paid.",
    },
  ],
  zorGrand: [
    {
      id: 1,
      question:
        "What is the process for purchasing a Mahindra Grand Zor from Turno?",
      answer:
        "To know the process of purchasing Mahindra Zor Grand you can call Turno EV Experts or visit the Turno website.",
    },
    {
      id: 2,
      question:
        "Can I schedule a test drive of the Mahindra Grand Zor at Turno?",
      answer:
        "Yes, you can. Once you book the electric auto on the website, a Turno expert will help you book the test drive right from home.",
    },
    {
      id: 3,
      question:
        "What financing options are available for purchasing the Mahindra Grand Zor at Turno?",
      answer:
        "You can apply for your EV three-wheeler loan through the Turno website or app. You will be eligible for a buy-back option too after three years for a maximum of up to ₹150,000.",
    },
    {
      id: 4,
      question:
        "Is the Mahindra Grand Zor suitable for city driving and congested areas?",
      answer:
        "Mahindra Zor Grand is built for Indian cities. It can easily navigate through Indian streets thanks to the robust built and sleek body.",
    },
    {
      id: 5,
      question:
        "Can I charge the Mahindra Grand Zor at home or do I need specialized charging stations?",
      answer:
        "You can charge the Mahindra Zor Grand easily at your home using normal charging plug points.",
    },
    {
      id: 6,
      question:
        "Are there any maintenance requirements specific to the Mahindra Grand Zor?",
      answer:
        "Mahindra Zor Grand requires minimal maintenance. You should service this vehicle at regular intervals as advised by the manufacturers.",
    },
    {
      id: 7,
      question:
        "Does the Mahindra Grand Zor come with any connectivity features or smart technologies?",
      answer:
        "Yes, the Mahindra Zor Grand has an app where you can use geolocation and keep track of the vehicle and manage it from wherever you are.",
    },
    {
      id: 8,
      question:
        "Can I customize the Mahindra Grand Zor to suit my business needs?",
      answer:
        "Turno has partnered with best-selling commercial vehicles across India to cater to different needs. All you have to do is contact one of our experts, and they’ll tell you which EV fits your business.",
    },
    {
      id: 9,
      question:
        "Can I trade in my existing vehicle at Turno when purchasing the Mahindra Grand Zor?",
      answer:
        "Yes, you can exchange your existing vehicle for an electric auto.",
    },
    {
      id: 10,
      question:
        "What documents do I need to bring to Turno when purchasing the Mahindra Zor Grand?",
      answer:
        "Turno needs minimal documents like your PAN Card and Aadhar Card to purchase the vehicle.",
    },
    {
      id: 11,
      question:
        "What are the warranty terms and coverage for the Mahindra Grand Zor?",
      answer:
        "You get a 5-year warranty on the battery and a 3-year warranty on the EV itself.",
    },
    {
      id: 12,
      question: "What are the delivery timelines for the Mahindra Grand Zor?",
      answer:
        "It usually takes us 5 days to deliver the electric vehicle after the booking amount is paid.",
    },
    {
      id: 13,
      question: "What is the loading capacity of Mahindra Zor Grand?",
      answer:
        "The loading capacity of the Mahindra Zor Grand is about 550 kgs.",
    },
    {
      id: 14,
      question: "What is the engine capacity of Mahindra Zor Grand?",
      answer:
        "Since Mahindra Zor Grand is an electric commercial vehicle, it doesn't have an engine. It is driven by a powerful motor, a 12 kW motor which generates 17 bhp power.",
    },
  ],
  piaggioFX: [
    {
      id: 1,
      question:
        "What is the process for purchasing a Piaggio Ape E-Xtra Fx from Turno?",
      answer:
        "To purchase a Piaggio Ape E-Xtra Fx from Turno, simply visit our website or download our app. Browse through our range of electric commercial vehicles, select the Piaggio Ape E-Xtra Fx, and click on the 'Buy Now' button. Follow the on-screen instructions to complete your purchase.",
    },
    {
      id: 2,
      question:
        "Can I schedule a test drive of the Piaggio Ape E-Xtra Fx at Turno?",
      answer:
        "Yes, you can schedule a test drive of the Piaggio Ape E-Xtra Fx through Turno. After booking the electric auto on our website, one of our Turno experts will assist you in scheduling a test drive from the comfort of your home.",
    },
    {
      id: 3,
      question:
        "What financing options are available for purchasing the Piaggio Ape E-Xtra Fx at Turno?",
      answer:
        "Turno offers various financing options for purchasing the Piaggio Ape E-Xtra Fx. You can apply for an EV three-wheeler loan directly through the Turno website or app. Additionally, after three years, you are eligible for a buy-back option, with a maximum value of up to ₹150,000.",
    },
    {
      id: 4,
      question:
        "Is the Piaggio Ape E-Xtra Fx suitable for city driving and congested areas?",
      answer:
        "Yes, the Piaggio Ape E-Xtra Fx is well-suited for city driving and congested areas. Its compact size and agile maneuverability make it an ideal choice for navigating through urban traffic and tight spaces.",
    },
    {
      id: 5,
      question:
        "Can I charge the Piaggio Ape E-Xtra Fx at home or do I need specialized charging stations?",
      answer:
        "You can conveniently charge the Piaggio Ape E-Xtra Fx at home using a standard electric outlet. There's no need for specialized charging stations.",
    },
    {
      id: 6,
      question:
        "Are there any maintenance requirements specific to the Piaggio Ape E-Xtra Fx?",
      answer:
        "The Piaggio Ape E-Xtra Fx has minimal maintenance requirements. Regular check-ups and basic servicing are typically sufficient to keep the electric auto in excellent condition.",
    },
    {
      id: 7,
      question:
        "Does the Piaggio Ape E-Xtra Fx come with any connectivity features or smart technologies?",
      answer:
        "Yes, the Piaggio Ape E-Xtra Fx comes with connectivity features and smart technologies. It includes a dedicated app that allows you to track the vehicle's location using geolocation and manage it remotely from anywhere.",
    },
    {
      id: 8,
      question:
        "Can I customize the Piaggio Ape E-Xtra Fx to suit my business needs?",
      answer:
        "Turno has partnered with a variety of best-selling commercial vehicles across India to meet diverse business needs. You can contact one of our experts, and they will assist you in selecting the EV that best suits your business requirements.",
    },
    {
      id: 9,
      question:
        "Can I trade in my existing vehicle at Turno when purchasing the Piaggio Ape E-Xtra Fx?",
      answer:
        "Yes, you can trade in your existing vehicle when purchasing the Piaggio Ape E-Xtra Fx through Turno. Our team will assess the value of your current vehicle and apply it as a credit toward your electric auto purchase.",
    },
    {
      id: 10,
      question:
        "What documents do I need to bring to Turno when purchasing the Piaggio Ape E-Xtra Fx?",
      answer:
        "When purchasing the Piaggio Ape E-Xtra Fx, you only need your PAN Card and the Aadhar Card.",
    },
    {
      id: 11,
      question:
        "What are the warranty terms and coverage for the Piaggio Ape E-Xtra Fx?",
      answer:
        "The Piaggio Ape E-Xtra Fx comes with a 5-year warranty on the battery and a 3-year warranty on the electric vehicle itself. This comprehensive warranty coverage ensures peace of mind for your investment.",
    },
    {
      id: 12,
      question:
        "What are the delivery timelines for the Piaggio Ape E-Xtra Fx?",
      answer:
        "Typically, Turno delivers the Piaggio Ape E-Xtra Fx within 5 days after the booking amount is paid. We strive to provide a swift and hassle-free delivery process for your convenience.",
    },
  ],
  piaggioFXMax: [
    {
      id: 1,
      question:
        "What is the process for purchasing a Piaggio Ape E-Xtra Fx Max from Turno?",
      answer:
        "Purchasing your Piaggio Ape E-Xtra Fx Max from Turno is simple. Visit our website or download our app, choose your vehicle, and follow the on-screen instructions to complete your purchase.",
    },
    {
      id: 2,
      question:
        "Can I schedule a test drive of the Piaggio Ape E-Xtra Fx Max at Turno?",
      answer:
        "Yes, you can schedule a test drive through Turno. After booking your electric auto on our website, one of our experts will assist you in scheduling a convenient test drive from your home.",
    },
    {
      id: 3,
      question:
        "What financing options are available for purchasing the Piaggio Ape E-Xtra Fx Max at Turno?",
      answer:
        "Turno offers various financing options, including electric three-wheeler loans. Additionally, you can take advantage of our buy-back option after three years, with a maximum value of up to ₹200,000.",
    },
    {
      id: 4,
      question:
        "Is the Piaggio Ape E-Xtra Fx Max suitable for city driving and congested areas?",
      answer:
        "Yes, its compact size and agile maneuverability make it an excellent choice for city driving and navigating congested areas.",
    },
    {
      id: 5,
      question:
        "Can I charge the Piaggio Ape E-Xtra Fx Max at home or do I need specialized charging stations?",
      answer:
        "You can conveniently charge the Piaggio Ape E-Xtra Fx Max at home using a standard electric outlet, eliminating the need for specialized charging stations.",
    },
    {
      id: 6,
      question:
        "Are there any maintenance requirements specific to the Piaggio Ape E-Xtra Fx Max?",
      answer:
        "The Piaggio Ape E-Xtra Fx Max has minimal maintenance requirements. Regular check-ups and basic servicing will keep your electric auto in excellent condition.",
    },
    {
      id: 7,
      question:
        "Does the Piaggio Ape E-Xtra Fx Max come with any connectivity features or smart technologies?",
      answer:
        "Yes, it includes the Telematics 2.0 app for real-time tracking and remote management of the vehicle's status and location.",
    },
    {
      id: 8,
      question:
        "Can I customize the Piaggio Ape E-Xtra Fx Max to suit my business needs?",
      answer:
        "Turno offers various commercial vehicles to cater to different business needs. Contact our experts to find the ideal electric vehicle for your business.",
    },
    {
      id: 9,
      question:
        "Can I trade in my existing vehicle at Turno when purchasing the Piaggio Ape E-Xtra Fx Max?",
      answer:
        "Yes, you can exchange your existing vehicle for an electric auto through Turno's exchange program.",
    },
    {
      id: 10,
      question:
        "What documents do I need to bring to Turno when purchasing the Piaggio Ape E-Xtra Fx Max?",
      answer: "You'll need your PAN Card and Aadhar Card for the purchase.",
    },
    {
      id: 11,
      question:
        "What are the warranty terms and coverage for the Piaggio Ape E-Xtra Fx Max?",
      answer:
        "You get a 3-year warranty on the electric vehicle itself and a 5-year warranty on the battery, ensuring peace of mind for your investment.",
    },
    {
      id: 12,
      question:
        "What are the delivery timelines for the Piaggio Ape E-Xtra Fx Max?",
      answer:
        "Typically, we deliver the electric vehicle within 5 days after the booking amount is paid, ensuring a quick and hassle-free process.",
    },
  ],

  greavesEltra: [
    {
      id: 1,
      question:
        "What is the process for purchasing a Greaves Eltra from Turno?",
      answer:
        "Purchasing the Greaves Eltra is straightforward. Visit our website or app to explore the vehicle and its variants. Once you've made your selection, proceed with the booking and financing options available. Our experts will guide you through the entire process.",
    },
    {
      id: 2,
      question: "Can I schedule a test drive of the Greaves Eltra at Turno?",
      answer:
        "Absolutely! After booking the electric auto on our website or app, one of our Turno experts will assist you in scheduling a test drive from the comfort of your home. We encourage you to experience the vehicle firsthand.",
    },
    {
      id: 3,
      question:
        "What financing options are available for purchasing the Greaves Eltra at Turno?",
      answer:
        "Turno offers hassle-free loan options for electric pickups, making it easier for your business to acquire the Greaves Eltra. You can apply for your EV three-wheeler loan through our website or app. Additionally, we provide a buy-back option after three years, with a maximum value of up to ₹150,000.",
    },
    {
      id: 4,
      question:
        "Is the Greaves Eltra suitable for city driving and congested areas?",
      answer:
        "Yes, the Greaves Eltra is well-suited for city driving and congested areas. Its compact size, quick acceleration, and maneuverability make it an excellent choice for navigating through urban traffic.",
    },
    {
      id: 5,
      question:
        "Can I charge the Greaves Eltra at home, or do I need specialized charging stations?",
      answer:
        "You can charge the Greaves Eltra at home using a standard electrical outlet. While specialized charging stations are available and can provide faster charging, they are not a requirement for charging this electric auto.",
    },
    {
      id: 6,
      question:
        "Are there any maintenance requirements specific to the Greaves Eltra?",
      answer:
        "The Greaves Eltra has lower maintenance requirements compared to traditional vehicles. Regular check-ups and servicing by certified technicians are recommended. Turno provides free doorstep servicing to ensure your electric auto stays in top condition.",
    },
    {
      id: 7,
      question:
        "Does the Greaves Eltra come with any connectivity features or smart technologies?",
      answer:
        "Yes, the Greaves Eltra offers smart features. It has a dedicated app where you can use geolocation tracking and manage the vehicle remotely, providing convenience and peace of mind.",
    },
    {
      id: 8,
      question: "Can I customize the Greaves Eltra to suit my business needs?",
      answer:
        "Greaves Eltra electric vehicles are available in three widely used variants like Flatbed, Pick-up, and Full-body. If required, this electric truck can be further modified according to your business needs.",
    },
    {
      id: 9,
      question:
        "Can I trade in my existing vehicle at Turno when purchasing the Greaves Eltra?",
      answer:
        "Yes, you can take advantage of Turno's vehicle exchange program to transition from your existing vehicle to the Greaves Eltra electric auto.",
    },
    {
      id: 10,
      question:
        "What documents do I need to bring to Turno when purchasing the Greaves Eltra?",
      answer:
        "While the specific documentation requirements may vary, you will typically need proof of identity, address, and vehicle ownership, along with the necessary financing documents. Our experts will guide you through the documentation process.",
    },
    {
      id: 11,
      question: "What are the delivery timelines for the Greaves Eltra?",
      answer:
        "Typically, it takes approximately 5 days to deliver the electric vehicle after the booking amount is paid. However, delivery times may vary based on location and demand. Our team will provide you with an estimated delivery date during the purchase process.",
    },
  ],

  touroMax: [
    {
      id: 1,
      question:
        "What is the process for purchasing an Etrio Tour Max ++ from Turno?",
      answer:
        "The process is simple. You can visit our website or app to explore the vehicle and its variants. Once you've made your selection, you can proceed with the booking and financing options available. Our experts will guide you through the entire process.",
    },
    {
      id: 2,
      question:
        "Can I schedule a test drive of the Etrio Tour Max ++ at Turno?",
      answer:
        "Yes, absolutely. After booking the electric auto on our website or app, one of our Turno experts will assist you in scheduling a test drive from the comfort of your home. We encourage you to experience the vehicle firsthand.",
    },
    {
      id: 3,
      question:
        "What financing options are available for purchasing the Etrio Tour Max ++ at Turno?",
      answer:
        "Turno offers hassle-free loan options for electric pickups. You can apply for your EV three-wheeler loan through our website or app. Additionally, we provide a buy-back option after three years, with a maximum value of up to ₹150,000.",
    },
    {
      id: 4,
      question:
        "Is the Etrio Tour Max ++ suitable for city driving and congested areas?",
      answer:
        "Yes, the Etrio Tour Max ++ is well-suited for city driving and congested areas. Its compact size, quick acceleration, and maneuverability make it an excellent choice for navigating through urban traffic.",
    },
    {
      id: 5,
      question:
        "Can I charge the Etrio Tour Max ++ at home, or do I need specialized charging stations?",
      answer:
        "You can charge the Etrio Tour Max ++ at home using a standard electrical outlet. While specialized charging stations are available and can provide faster charging, they are not a requirement for charging this electric auto.",
    },
    {
      id: 6,
      question:
        "Are there any maintenance requirements specific to the Etrio Tour Max ++?",
      answer:
        "The Etrio Tour Max ++ has lower maintenance requirements compared to traditional vehicles. Regular check-ups and servicing by certified technicians are recommended. Turno provides free doorstep servicing to ensure your electric auto stays in top condition.",
    },
    {
      id: 7,
      question:
        "Does the Etrio Tour Max ++ come with any connectivity features or smart technologies?",
      answer:
        "Yes, the Etrio Tour Max ++ offers smart features. It has a dedicated app that enables geolocation tracking and vehicle management, allowing you to monitor and control the vehicle from anywhere.",
    },
    {
      id: 8,
      question:
        "Can I customize the Etrio Tour Max ++ to suit my business needs?",
      answer:
        "Absolutely, Turno offers various customization options to cater to different business needs. We've partnered with leading commercial vehicle manufacturers in India, and our experts can help you choose the EV that best fits your business requirements.",
    },
    {
      id: 9,
      question:
        "Can I trade in my existing vehicle at Turno when purchasing the Etrio Tour Max ++?",
      answer:
        "Yes, you can take advantage of Turno's vehicle exchange program to transition from your existing vehicle to the Etrio Tour Max ++ electric auto.",
    },
    {
      id: 10,
      question:
        "What documents do I need to bring to Turno when purchasing the Etrio Tour Max ++?",
      answer:
        "While the specific documentation requirements may vary, you will typically need proof of identity, address, and vehicle ownership, along with the necessary financing documents. Our experts will guide you through the documentation process.",
    },
    {
      id: 11,
      question:
        "What are the warranty terms and coverage for the Etrio Tour Max ++?",
      answer:
        "You will receive a 3-year warranty or up to 150,000 km, whichever comes first, when you purchase the Etrio Tour Max ++.",
    },
    {
      id: 12,
      question: "What are the delivery timelines for the Etrio Tour Max ++?",
      answer:
        "Typically, it takes approximately 5 days to deliver the electric vehicle after the booking amount is paid. However, delivery times may vary based on location and demand. Our team will provide you with an estimated delivery date during the purchase process.",
    },
    {
      id: 13,
      question:
        "What is the process for purchasing a Greaves Eltra from Turno?",
      answer:
        "Purchasing the Greaves Eltra is straightforward. Visit our website or app to explore the vehicle and its variants. Once you've made your selection, proceed with the booking and financing options available. Our experts will guide you through the entire process.",
    },
  ],

  hiLoadDV: [
    {
      id: 1,
      question:
        "What is the process for purchasing an Euler HiLoad from Turno?",
      answer:
        "Purchasing the Euler HiLoad is straightforward. Visit our website or app to explore the vehicle and its variants. Once you've made your selection, proceed with the booking and financing options available. Our experts will guide you through the entire process.",
    },
    {
      id: 2,
      question: "Can I schedule a test drive of the Euler HiLoad at Turno?",
      answer:
        "Absolutely! After booking the electric auto on our website or app, one of our Turno experts will assist you in scheduling a test drive from the comfort of your home. We encourage you to experience the vehicle firsthand.",
    },
    {
      id: 3,
      question:
        "What financing options are available for purchasing the Euler HiLoad at Turno?",
      answer:
        "Turno offers hassle-free loan options for electric pickups, making it easier for your business to acquire the Euler HiLoad. You can apply for your EV three-wheeler loan through our website or app. Additionally, we provide a buy-back option after three years, with a maximum value of up to ₹150,000.",
    },
    {
      id: 4,
      question:
        "Is the Euler HiLoad suitable for city driving and congested areas?",
      answer:
        "Yes, the Euler HiLoad is well-suited for city driving and congested areas. Its compact size, quick acceleration, and maneuverability make it an excellent choice for navigating through urban traffic.",
    },
    {
      id: 5,
      question:
        "Can I charge the Euler HiLoad at home, or do I need specialized charging stations?",
      answer:
        "You can charge the Euler HiLoad at home using a standard electrical outlet. While specialized charging stations are available and can provide faster charging, they are not a requirement for charging this electric auto.",
    },
    {
      id: 6,
      question:
        "Are there any maintenance requirements specific to the Euler HiLoad?",
      answer:
        "The Euler HiLoad has lower maintenance requirements compared to traditional vehicles. Regular check-ups and servicing by certified technicians are recommended. Turno provides free doorstep servicing to ensure your electric auto stays in top condition.",
    },
    {
      id: 7,
      question:
        "Does the Euler HiLoad come with any connectivity features or smart technologies?",
      answer:
        "Yes, the Euler HiLoad offers smart features. It has a dedicated app where you can use geolocation tracking and manage the vehicle remotely, providing convenience and peace of mind.",
    },
    {
      id: 8,
      question: "Can I customize the Euler HiLoad to suit my business needs?",
      answer:
        "Certainly! Turno offers various customization options to cater to different business needs. We've partnered with leading commercial vehicle manufacturers in India, and our experts can help you choose the EV that best fits your business requirements.",
    },
    {
      id: 9,
      question:
        "Can I trade in my existing vehicle at Turno when purchasing the Euler HiLoad?",
      answer:
        "Yes, you can take advantage of Turno's vehicle exchange program to transition from your existing vehicle to the Euler HiLoad electric auto.",
    },
    {
      id: 10,
      question:
        "What documents do I need to bring to Turno when purchasing the Euler HiLoad?",
      answer:
        "While the specific documentation requirements may vary, you will typically need proof of identity, address, and vehicle ownership, along with the necessary financing documents. Our experts will guide you through the documentation process.",
    },
  ],
  neev: [
    {
      id: 1,
      question: "How can I purchase an Altigreen neEV from your dealership?",
      answer:
        "Ans: Purchasing the Altigreen neEV is straightforward. Visit our website or app to explore the vehicle and its variants. Once you've made your selection, proceed with the booking and financing options available. Our experts will guide you through the entire process.",
    },
    {
      id: 2,
      question:
        "Can I schedule a test drive of the Altigreen neEV at your dealership?",
      answer:
        "Ans: Absolutely! After booking the electric cargo vehicle on our website or app, one of our experts will assist you in scheduling a test drive from the comfort of your home. We encourage you to experience the vehicle firsthand.",
    },
    {
      id: 3,
      question:
        "What financing options do you offer for purchasing the Altigreen neEV?",
      answer:
        "Ans: Turno provides hassle-free loan options for electric cargo vehicles, making it easier for your business to acquire the Altigreen neEV. You can apply for your neEV loan through our website or app. Additionally, we offer a buy-back option after three years, with a maximum value of up to ₹150,000.",
    },
    {
      id: 4,
      question:
        "Is the Altigreen neEV suitable for city driving and congested areas?",
      answer:
        "Ans: Yes, the Altigreen neEV is well-suited for city driving and congested areas. Its compact size, quick acceleration, and maneuverability make it an excellent choice for navigating through urban traffic.",
    },
    {
      id: 5,
      question:
        "Can I charge the Altigreen neEV at home, or do I need specialized charging stations?",
      answer:
        "Ans: You can charge the Altigreen neEV at home using a standard electrical outlet. While specialized charging stations are available and can provide faster charging, they are not a requirement for charging this electric cargo vehicle.",
    },
    {
      id: 6,
      question:
        "Are there any maintenance requirements specific to the Altigreen neEV?",
      answer:
        "Ans: The Altigreen neEV has lower maintenance requirements compared to traditional vehicles. Regular check-ups and servicing by certified technicians are recommended. We provide free doorstep servicing to ensure your electric cargo vehicle stays in top condition.",
    },
    {
      id: 7,
      question:
        "Does the Altigreen neEV come with any connectivity features or smart technologies?",
      answer:
        "Ans: Yes, the Altigreen neEV offers smart features. It has a dedicated app where you can use geolocation tracking and manage the vehicle remotely, providing convenience and peace of mind.",
    },
    {
      id: 8,
      question: "Can I customize the Altigreen neEV to suit my business needs?",
      answer:
        "Ans: Certainly! We offer various customization options to cater to different business requirements. Our experts can help you choose the neEV variant that best fits your business needs.",
    },
    {
      id: 9,
      question:
        "Can I trade in my existing vehicle when purchasing the Altigreen neEV?",
      answer:
        "Ans: Yes, you can take advantage of our vehicle exchange program to transition from your existing vehicle to the Altigreen neEV electric cargo vehicle.",
    },
    {
      id: 10,
      question:
        "What documents do I need to bring when purchasing the Altigreen neEV from your dealership?",
      answer:
        "Ans: While the specific documentation requirements may vary, you will typically need proof of identity, address, and vehicle ownership, along with the necessary financing documents. Our experts will guide you through the documentation process.",
    },
  ],

  montraePV: [
    {
      id: 1,
      question: "What is the range of the Montra Electric auto?",
      answer:
        "The Montra Electric Super Auto has a range of over 160+ km on a single charge. This is one of the highest ranges of any electric auto available in the market, making it a great option for passenger transportation service.",
    },
    {
      id: 2,
      question: "What is the top speed of the Montra Electric Super Auto?",
      answer: "The Montra Electric Super Auto has a top speed of 55 km/h.",
    },
    {
      id: 3,
      question: "What is the latest Montra electric auto price?",
      answer:
        "The Montra Electric Super Auto will cost you around ₹3.5 - ₹4 lakhs. Auto prices vary due to state subsidies and taxes. For the exact price in your state, please contact Turno experts at 08047482233.",
    },
    {
      id: 4,
      question: "What are the features of the Montra Electric Super Auto?",
      answer:
        "The features of the Montra Electric Super Auto are:\n- A spacious interior with plenty of leg, head, and boot space\n- Torque of 60 Nm for plenty of power\n- A smooth ride and a fully digital instrument cluster",
    },
    {
      id: 5,
      question: "Where can I buy a Montra electric auto?",
      answer:
        "If you want to purchase a Montra electric Super Auto, please contact Turno experts at Turno.club. At Turno, you will get free doorstep test drives, easy vehicle financing, quick vehicle delivery, and post-sale support such as scheduling regular servicing, extended customer support, and more.",
    },
    {
      id: 6,
      question: "Can I take the test drive of a Montra Electric Super Auto?",
      answer:
        "Yes. You can take free test drives of Montra Electric Super Auto at Turno. Call us at 08047482233 to schedule a free test drive.",
    },
    {
      id: 7,
      question: "What is the warranty on a Montra electric auto?",
      answer:
        "The Montra Electric Super Auto comes with a 3-year/10,000 km warranty, whichever comes earlier.",
    },
    {
      id: 8,
      question: "Can I get finance for Montra Electric Super Auto at Turno?",
      answer:
        "Yes, we provide 100% assured EV loans at a flat interest rate starting at 10.5%. To learn more about the financing options available at Turno, please contact us at 08047482233.",
    },
    {
      id: 9,
      question:
        "Is Montra passenger electric auto suitable for driving in the city and congested areas?",
      answer:
        "Yes, the Montra passenger electric auto is well-suited for driving in the city and congested areas. Its compact size and agile manoeuvrability make it an ideal choice for navigating through urban traffic and tight spaces.",
    },
    {
      id: 10,
      question: "Why is Montra electric auto better than CNG auto?",
      answer:
        "The most significant benefit of owning a Montra EV over a CNG EV is the cost savings. The running cost of a CNG auto is ₹4/km, whereas it costs just ₹0.40/km with the Montra EV, resulting in a 90% reduction in running costs.",
    },
    {
      id: 12,
      question:
        "What are the benefits of purchasing my Montra electric auto from Turno?",
      answer:
        "We help buyers to choose the best electric 3-wheeler vehicle for their business along with easy financing and assured resale. Along with that, we provide excellent post-sale service such as scheduling periodic maintenance service, video call assisting for non-critical issues, and providing assured resale value up to 1.5L after 3 years and more.",
    },
  ],
  piaggioEcityFx: [
    {
      id: 1,
      question: "What is the range of the electric Piaggio ape auto?",
      answer:
        "The electric Piaggio ape auto has a range of over 110 km on a single charge.",
    },
    {
      id: 2,
      question: "What is the top speed of the electric Piaggio ape auto?",
      answer: "The electric Piaggio ape auto has a top speed of 45 km/h.",
    },
    {
      id: 3,
      question: "What is the latest Piaggio electric auto price?",
      answer:
        "The Ape electric auto price is around ₹XX - ₹X lakhs. Please note that Ape electric auto on-road price may vary due to state subsidies and taxes. For the exact price in your state, please contact Turno experts at 08047482233.",
    },
    {
      id: 4,
      question:
        "What are the features of the electric Piaggio Ape passenger auto?",
      answer: `The features of the electric Piaggio Ape passenger auto are:
        A spacious interior with plenty of leg, head, and boot space,
        Lowest running cost in the industry-  39p/km,
         Industry-leading warranty of 1,75,000 km`,
    },
    {
      id: 5,
      question: "Where can I buy an electric Piaggio Ape passenger auto?",
      answer:
        "If you want to purchase a Piaggio Ape passenger auto, please contact EV experts at Turno. club. At Turno, you will get free doorstep test drives, easy vehicle financing, quick vehicle delivery, and post-sale support such as scheduling regular servicing, extended customer support, and more.",
    },
    {
      id: 6,
      question:
        "Can I take the test drive of an electric Piaggio Ape passenger auto?",
      answer:
        "Yes. You can take free test drives of an electric Piaggio Ape passenger auto at Turno. Call us at 08047482233 to schedule a free test drive.",
    },
    {
      id: 7,
      question:
        "What is the warranty on an electric Piaggio Ape passenger auto?",
      answer:
        "The electric Piaggio Ape passenger auto comes with a 3-year/1,75,000 km warranty, whichever comes earlier.",
    },
    {
      id: 8,
      question:
        "Can I get finance for an electric Piaggio Ape passenger auto at Turno?",
      answer:
        "Yes, we provide 100% assured EV loans at a flat interest rate starting at 10.5%. To learn more about the financing options available at Turno, please contact us at 08047482233.",
    },
    {
      id: 9,
      question:
        "Is Piaggio passenger electric auto suitable for driving in the city and congested areas?",
      answer:
        "Yes, the PIaggio passenger electric auto is well-suited for driving in the city and congested areas. Its compact size and agile manoeuvrability make it an ideal choice for navigating through urban traffic and tight spaces.",
    },
    {
      id: 10,
      question: "Why Piaggio electric auto is better than CNG auto?",
      answer:
        "The most significant benefit of owning a electric Piaggio ape auto over a CNG EV is the cost savings. The running cost of a CNG auto is ₹4/km, whereas it costs just ₹0.39/km with the electric Piaggio ape auto, resulting in a 90% reduction in running costs.",
    },
    {
      id: 11,
      question: "What are the benefits of purchasing my Piaggio from Turno?",
      answer:
        "We help buyers to choose the best electric 3-wheeler vehicle for their business along with easy financing and assured resale. Along with that, we provide excellent post-sale service such as scheduling periodic maintenance service, video call assisting for non-critical issues, and providing assured resale value up to 1.5L after 3 years and more.",
    },
  ],
  bajajAutoRikshaw: [
    {
      id: 1,
      question: "What is the range of the Bajaj electric passenger auto ?",
      answer:
        "The electric Bajaj auto has a range of over 178 km on a single charge. This is one of the highest ranges of any electric auto available in the market, making it a great option for passenger transportation service.",
    },
    {
      id: 2,
      question: "What is the top speed of the Bajaj electric auto rickshaw?",
      answer: "The Bajaj auto electric vehicle has a top speed of 45 km/h",
    },
    {
      id: 3,
      question: "What are the features of the Bajaj electric passenger auto?",
      answer: "The features of the Bajaj electric passenger auto are:",
      subPoints: [
        "Eco-Friendly: Produces zero emissions for a sustainableride.",
        "Low Maintenance: Requires minimal upkeep compared to CNG autos.",
        "Smart Features: Offers a digital instrument cluster.",
      ],
    },
    {
      id: 4,
      question: "What is the latest Bajaj electric auto price?",
      answer:
        "Bajaj RE electric auto rickshaw price starts from ₹3.6 lakhs. Auto prices vary due to state subsidies and taxes. For the exact price in your state, please contact Turno experts at 08047482233.",
    },
    {
      id: 5,
      question: "Where can I buy a Bajaj electric auto rickshaw?",
      answer:
        "If you want to purchase a Bajaj electric auto rickshaw, please contact EV experts or www.turno.club. At Turno, you will get free doorstep test drives, easy vehicle financing, quick vehicle delivery, and post-sale support such as scheduling regular servicing, extended customer support, and more.",
    },
    {
      id: 6,
      question: "Can I take the test drive of a Bajaj electric passenger auto?",
      answer:
        "Yes. You can take free test drives of an electric Bajaj passenger auto at Turno showroom or schedule a test drive at your doorstep. Call us at 08047482233 to schedule a free test drive.",
    },
    {
      id: 7,
      question: "What is the warranty on a Bajaj electric auto rickshaw?",
      answer:
        "The  Bajaj electric auto rickshaw passenger auto comes with a 5-year or 120,000 km warranty.",
    },
    {
      id: 8,
      question: "Can I get finance for Bajaj passenger auto at Turno?",
      answer:
        "Yes, we provide 100% assured EV loans at a flat interest rate starting at 10.5%. To learn more about the financing options available at Turno, please contact us at 08047482233",
    },
    {
      id: 9,
      question:
        "Is Bajaj passenger electric auto suitable for driving in the city and congested areas?",
      answer:
        "Yes, the Bajaj passenger electric auto is well-suited for driving in the city and congested areas. Its compact size and agile manoeuvrability make it an ideal choice for navigating through urban traffic and tight spaces.",
    },
    {
      id: 10,
      question: "Why is Bajaj electric auto better than CNG auto?",
      answer:
        "The most significant benefit of owning an electric  Bajaj RE E TEC 9.0 auto over a CNG EV is the cost savings. The running cost of a CNG auto is ₹4/km, whereas it costs approximately ₹0.40/km with the electric Bajaj auto, resulting in a 90% reduction in running costs.",
    },
    {
      id: 11,
      question:
        "What are the benefits of purchasing my Bajaj RE E TEC 9.0 from Turno?",
      answer:
        "We help buyers to choose the best electric 3-wheeler vehicle for their business along with easy financing and assured resale. Along with that, we provide excellent post-sale service such as scheduling periodic maintenance service, video call assisting for non-critical issues, and providing assured resale value up to 1.5L after 3 years.",
    },
  ],
  MahindraTreoPlus: [
    {
      id: 1,
      question: "What is the range of the Mahindra electric auto?",
      answer:
        "The Mahindra Treo Plus has a certified range of 150 km on a single charge. However, the typical driving falls between 100-110 km, making it a great option for passenger transportation service.",
    },
    {
      id: 2,
      question: "What is the top speed of the Mahindra Treo Plus?",
      answer: "The  Mahindra Treo Plus has a top speed of 55 km/h.",
    },
    {
      id: 3,
      question: "What is Treo auto price in my location?",
      answer:
        "The Mahindra rickshaw price starts at ₹3.85 lakhs. However, to know the exact price in your city,  please contact us at 08047482233.",
    },
    {
      id: 4,
      question: "What are the features of the  Mahindra Treo Plus?",
      answer: "The features of the  Mahindra Treo Plus are:",
      subPoints: [
        "Zero Emissions: Breathe easily with cleaner air for today and the future.",
        "Cost-Effective: Save big with running costs as low as 40 paise per km.",
        "Built to Last: Mahindra's quality shines through with a robust chassis.",
        "Peace of Mind: Trust the 3-year warranty on the battery and motor for hassle-free rides.",
        "Easy Maneuvering: Handlebar steering makes navigating a breeze.",
        "Safe Stopping: Hydraulic drum brakes ensure confident control.",
      ],
    },
    {
      id: 5,
      question: "Where can I buy a Mahindra Treo Plus auto?",
      answer:
        "If you want to purchase a Mahindra Treo Plus auto, please contact EV experts at Turno.club. At Turno, you will get free doorstep test drives, easy vehicle financing, quick vehicle delivery, and post-sale support such as scheduling regular servicing, extended customer support, and more.",
    },
    {
      id: 6,
      question: "Can I take the test drive of a Mahindra Treo Plus auto?",
      answer:
        "Yes. You can take free test drives of the Mahindra Treo Plus auto at Turno. Call us at 08047482233 to schedule a free test drive.",
    },
    {
      id: 7,
      question: "What is the warranty on a Mahindra electric auto?",
      answer:
        "The Mahindra passenger auto has a 3-year/80,000km standard and a 2-year / 20,000 km extended warranty",
    },
    {
      id: 8,
      question: "Can I get finance for  Mahindra passenger auto auto at Turno?",
      answer:
        "Yes, we provide 100% assured EV loans at a flat interest rate starting at 10.5%. To learn more about the financing options available at Turno, please contact us at 08047482233",
    },
    {
      id: 9,
      question:
        "Is Mahindra Treo Plus auto suitable for driving in the city and congested areas?",
      answer:
        "Yes, the Mahindra Treo Plus auto is well-suited for driving in the city and congested areas. Its compact size and agile manoeuvrability make it an ideal choice for navigating through urban traffic and tight spaces.",
    },
    {
      id: 10,
      question: "Why Mahindra Treo Plus auto is better than CNG auto?",
      answer:
        "The most significant benefit of owning a Mahindra passenger EV auto over a CNG EV is the cost savings. The running cost of a CNG auto is ₹4/km, whereas it costs just ₹0.40/km with the  Mahindra passenger EV auto, resulting in a nearly 90% reduction in running costs.",
    },
    {
      id: 11,
      question: "What is the seating capacity of Mahindra Electric Auto?",
      answer:
        "Mahindra e rickshaw has a seating capacity of driver + 3 passengers.",
    },
    {
      id: 12,
      question:
        "What are the benefits of purchasing my Mahindra Treo Plus from Turno?",
      answer:
        "At Turno, we make EV buying easier than ever before with 100% guaranteed financing, 2-day delivery, test drive and documentation at home. We also provide excellent post-sale service such as scheduling periodic maintenance service, video call assisting for non-critical issues, and providing assured resale value up to 1.5L after 3 years and more.",
    },
    {
      id: 13,
      question: "Can I get an offer on Mahindra Treo on road price?",
      answer:
        "At Turno, we run region-specific offers and discounts. Please contact us at 08047482233 to know the ongoing offers on Mahindra Treo e rickshaw in your area.",
    },
  ],
  // You can now use the faqData array to access the questions and answers as needed.
};

export const brandFAQsHindi = {
  mahindra: [
    {
      id: 1,
      question: "महिंद्रा ट्रियो इलेक्ट्रिक ऑटो की कीमत क्या हैं?",
      answer:
        "महिंद्रा ट्रियो इलेक्ट्रिक ऑटो की कीमत मॉडल, विशेषताएँ और शहरों  के आधार पर अलग हो सकती हैं। महिंद्रा ट्रियो इलेक्ट्रिक ऑटो की कीमत लगभग 3.63 लाख रुपए से शुरू होती हैं। इस गाड़ी की सठीक और वर्तमान मूल्य जानने के लिए कृपया टर्नो की वेबसाइट पर जाएं।",
    },
    {
      id: 2,
      question: "महिंद्रा इलेक्ट्रिक ऑटो कितनी माइलेज देती हैं?",
      answer:
        "महिंद्रा इलेक्ट्रिक ऑटो की माइलेज मॉडल और बैटरी पर निर्भर करता हैं। महिंद्रा इलेक्ट्रिक ऑटो को अधिक दूर जाने के लिए डिज़ाइन किया गया हैं  और एक चार्ज पर लगभग 115 किलोमीटर तक चल सकती हैंं । महिंद्रा इलेक्ट्रिक ऑटो की सठीक माइलेज जानने के लिए, कृपया टर्नो एक्सपर्ट से संपर्क  करें ।",
    },
    {
      id: 3,
      question: "महिंद्रा इलेक्ट्रिक ऑटो मे कितना सामान लोड कर सकते हैं?",
      answer:
        "महिंद्रा ट्रियो की लोडिंग  क्षमता मॉडल के ऊपर निर्भर करता हैं। आपकी पसंदीदा  महिंद्रा इलेक्ट्रिक ऑटो का सही लोड कैपेसिटी जानने के लिए आज ही टर्नो एक्सपर्ट्स को कॉल करे।",
    },
    {
      id: 4,
      question: "महिन्द्रा ट्रेओ की प्रति कि.मी. लागत क्या हैं?",
      answer:
        " महिंद्रा ट्रियो को एक किलोमीटर चलाने का खर्च कई चीज़ो पर निर्भर करता हैं, जैसे बिजली का दाम, बैटरी की कैपेसिटी, गाड़ी चलाने का तरीका, और रखरखाव का खर्च। महिंद्रा इलेक्ट्रिक गाड़ी को एक किलोमीटर चलने की कीमत सिर्फ 75 पैसे हैं। महिंद्रा ट्रियो को चलाने का खर्च, सामान्य पेट्रोल या डीजल गाड़ियो के मुकाबले काफी कम हैं, और ये इसीलिए प्रसिद्ध हैं।",
    },
    {
      id: 5,
      question: "महिंद्रा इलेक्ट्रिक ऑटो कितने किलोमीटर चलता हैं?",
      answer:
        "महिंद्रा इलेक्ट्रिक ऑटो एक बार चार्ज करने पर 115 किलोमीटर तक चल सकती हैं। सठीक दूरी जानने के लिए आप टर्नो एक्सपर्ट को कॉल कर सकते हैं। टर्नो एक्सपर्ट इलेक्ट्रिक गाड़ी के विषय मे आपके सभी प्रश्नो का उत्तर देने के लिए हमेशा उपलब्ध हैं।",
    },
  ],
};

export const brandFAQsKannada = {
  mahindra: [
    {
      id: 1,
      question: "ಮಹೀಂದ್ರ ಟ್ರಿಯೊ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋ ಬೆಲೆ ಎಷ್ಟು?",
      answer:
        "ನಿರ್ದಿಷ್ಟ ರೂಪಾಂತರ, ವೈಶಿಷ್ಟ್ಯಗಳು ಮತ್ತು ಸ್ಥಳವನ್ನು ಅವಲಂಬಿಸಿ ಮಹೀಂದ್ರಾ ಟ್ರಿಯೊ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋ ಬೆಲೆಯು ಬದಲಾಗಬಹುದು, ನೀವು 3.63 ಲಕ್ಷ ರೂಪಾಯಿಗಳ ಆರಂಭಿಕ ಬೆಲೆಯಲ್ಲಿ ಮಹೀಂದ್ರಾ ಮೂರು ಚಕ್ರದ ಕಾರ್ಗೋವನ್ನು ಪಡೆಯಬಹುದು. ನಿಖರವಾದ ಮತ್ತು ಅಪ್-ಟು-ಡೇಟ್ ಬೆಲೆ ಮಾಹಿತಿಗಾಗಿ, ನೀವು turno.club ಗೆ ಲಾಗ್ ಇನ್ ಮಾಡಬಹುದು.",
    },
    {
      id: 2,
      question: "ಮಹೀಂದ್ರ EV ಆಟೋ ಮೈಲೇಜ್ ಎಷ್ಟು?",
      answer:
        "ಮಹೀಂದ್ರ EV ಆಟೋದ ಮೈಲೇಜ್ ಅಥವಾ ಶ್ರೇಣಿಯು ನಿರ್ದಿಷ್ಟ ಮಾದರಿ ಮತ್ತು ಬ್ಯಾಟರಿ ಸಾಮರ್ಥ್ಯದ ಮೇಲೆ ಅವಲಂಬಿತವಾಗಿರುತ್ತದೆ. ಮಹೀಂದ್ರ ಬ್ಯಾಟರಿ ಆಟೋ ಸಾಕಷ್ಟು ಶ್ರೇಣಿಯನ್ನು ನೀಡಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ ಮತ್ತು ಒಂದೇ ಚಾರ್ಜ್‌ನಲ್ಲಿ 125 ಕಿಮೀ ವರೆಗೆ ಇರುತ್ತದೆ. ಮಹೀಂದ್ರ EV ಆಟೋ ಮೈಲೇಜ್‌ನ ನಿಖರವಾದ ವಿವರಗಳಿಗಾಗಿ, ದಯವಿಟ್ಟು ಟರ್ನೊ ವೆಬ್‌ಸೈಟ್ ಅನ್ನು ನೋಡಿ.",
    },
    {
      id: 3,
      question: "ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋಗಳ ಲೋಡಿಂಗ್ ಸಾಮರ್ಥ್ಯ ಎಷ್ಟು?",
      answer:
        "ಮಹೀಂದ್ರ ಟ್ರೆಯೊ ಅಥವಾ ಇತರ ಎಲೆಕ್ಟ್ರಿಕ್ ತ್ರಿಚಕ್ರ ವಾಹನಗಳಂತಹ ಮಹೀಂದ್ರ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋಗಳ ಲೋಡಿಂಗ್ ಸಾಮರ್ಥ್ಯವು ಮಾದರಿ ಮತ್ತು ಸಂರಚನೆಯ ಆಧಾರದ ಮೇಲೆ ಬದಲಾಗಬಹುದು. ಈ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋಗಳು ವಾಣಿಜ್ಯ ಬಳಕೆಗಾಗಿ ಉದ್ದೇಶಿತ-ನಿರ್ಮಿತವಾಗಿವೆ ಮತ್ತು ಅವುಗಳ ಲೋಡಿಂಗ್ ಸಾಮರ್ಥ್ಯಗಳನ್ನು ಸಾಮಾನ್ಯವಾಗಿ ವ್ಯವಹಾರಗಳು, ಲಾಜಿಸ್ಟಿಕ್ಸ್ ಮತ್ತು ಸರಕು ಸಾಗಣೆಯ ಬೇಡಿಕೆಗಳನ್ನು ಪೂರೈಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ. ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋದ ನಿರ್ದಿಷ್ಟ ಲೋಡಿಂಗ್ ಸಾಮರ್ಥ್ಯವನ್ನು ಕಂಡುಹಿಡಿಯಲು, ನೀವು ಟರ್ನೊಗೆ ಭೇಟಿ ನೀಡಬಹುದು.",
    },
    {
      id: 4,
      question: "ಪ್ರತಿ ಕಿ.ಮೀ.ಗೆ ಮಹೀಂದ್ರಾ ಟ್ರಿಯೊ ಬೆಲೆ ಎಷ್ಟು?",
      answer:
        "ಪ್ರತಿ ಕಿಲೋಮೀಟರ್‌ಗೆ (ಕಿಮೀ) ಮಹೀಂದ್ರಾ ಟ್ರಿಯೊ ಚಾಲನೆಯ ವೆಚ್ಚವು ವಿದ್ಯುತ್ ದರಗಳು, ಬ್ಯಾಟರಿ ಸಾಮರ್ಥ್ಯ, ಚಾಲನಾ ಪರಿಸ್ಥಿತಿಗಳು ಮತ್ತು ನಿರ್ವಹಣಾ ವೆಚ್ಚಗಳು ಸೇರಿದಂತೆ ಹಲವಾರು ಅಂಶಗಳ ಮೇಲೆ ಅವಲಂಬಿತವಾಗಿರುತ್ತದೆ. ಸಾಂಪ್ರದಾಯಿಕ ಪೆಟ್ರೋಲ್ ಅಥವಾ ಡೀಸೆಲ್ ವಾಹನಗಳಿಗೆ ಹೋಲಿಸಿದರೆ ಮಹೀಂದ್ರ ಟ್ರಿಯೊ ಸೇರಿದಂತೆ ಎಲೆಕ್ಟ್ರಿಕ್ ವಾಹನಗಳು ಕಡಿಮೆ ಕಾರ್ಯಾಚರಣೆಯ ವೆಚ್ಚಗಳಿಗೆ ಹೆಸರುವಾಸಿಯಾಗಿದೆ. ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ವಾಹನದ ಪ್ರತಿ ಕಿ.ಮೀ ವೆಚ್ಚವು 75p/km ಆಗಿರಬಹುದು.",
    },
    {
      id: 5,
      question: "ಮಹೀಂದ್ರಾ EV ಆಟೋ ಎಷ್ಟು ಕಿಮೀ ಬಾಳಿಕೆ ಬರಬಹುದು?",
      answer:
        "ಮಾದರಿ ಮತ್ತು ರೂಪಾಂತರಗಳ ಆಧಾರದ ಮೇಲೆ ಮಹೀಂದ್ರ EV ಗಳು ಒಂದೇ ಚಾರ್ಜ್‌ನಲ್ಲಿ 115 ಕಿಮೀ ವರೆಗೆ ಇರುತ್ತದೆ. ಆದಾಗ್ಯೂ ನಿಖರ ಮತ್ತು ಪ್ರಾಯೋಗಿಕ ಶ್ರೇಣಿಯನ್ನು ತಿಳಿಯಲು ನೀವು ಟರ್ನೊಗೆ ಕರೆ ಮಾಡಬಹುದು. ನಿಮ್ಮ ಎಲ್ಲಾ ವಿದ್ಯುತ್ ಲೋಡ್ ಗಾಡಿ ಸಂಬಂಧಿತ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಲು ಟರ್ನೊ EV ತಜ್ಞರು 24*7 ಲಭ್ಯವಿರುತ್ತಾರೆ.",
    },
  ],
};

export const postSalesFAQs = [
  {
    id: 1,
    question:
      "Are goods electric vehicles more expensive than fuel-powered autos?",
    answer:
      "No, electric autos and fuel-powered autos require a similar investment, approximately Rs. 2 lakhs. However, the total cost of owning an EV is less than half of owning a fuel-powered vehicle when calculated over three years. For more details on the total cost of ownership, please contact Turno EV experts.",
  },
  {
    id: 2,
    question:
      "What is Turno.club, and why should I buy my goods electric vehicle through Turno?",
    answer:
      "Turno is a one-stop destination for purchasing the best-selling commercial electric vehicles in the market. We assist buyers in choosing the best electric 3-wheeler vehicle for their business, offering easy financing and assured resale.",
  },
  {
    id: 3,
    question:
      "What are the additional benefits of buying an electric vehicle with Turno?",
    answer:
      "When you buy an EV with Turno, you not only get expert assistance and financing but also benefit from servicing support. We provide free replacement vehicles in case of breakdowns to ensure your business doesn't suffer.",
  },
  {
    id: 4,
    question:
      "In the event of a vehicle breakdown, will Turno be able to assist me?",
    answer:
      "Absolutely. Contact us, and our dedicated team will handle towing and repairs promptly.",
  },
  {
    id: 5,
    question: "Are Turno's services available nationwide?",
    answer:
      "Yes, our nationwide network of dealerships ensures a quick resolution to your concerns.",
  },
  {
    id: 6,
    question:
      "Can I get assistance from Turno regarding future vehicle-related issues?",
    answer:
      "Certainly, our dedicated team can help arrange fast-track vehicle repair services.",
  },
  {
    id: 7,
    question:
      "Can you fast-track my concern to get a quick resolution from the dealer?",
    answer:
      "Yes, our direct contact with dealers ensures swift resolutions to your vehicle-related queries.",
  },
  {
    id: 8,
    question: "How much will it cost me for one service?",
    answer:
      "Each service for your three-wheeler electric vehicle costs approximately ₹1250.",
  },
  {
    id: 9,
    question: "Where can I get my electric vehicle serviced?",
    answer:
      "Your vehicle must be serviced at an authorized service center to ensure the best service and genuine spare parts.",
  },
  {
    id: 10,
    question:
      "Can I get my electric vehicle serviced by a local mechanic instead of going to the OEM?",
    answer:
      "All EVs must be serviced at OEM-authorized service stations. Any tampering with electronic modules or wires will void the warranty, which typically ranges from 3 to 5 years based on different OEMs.",
  },
];

export const preSalesFAQs = [
  {
    id: 1,
    question:
      "What is Turno.club and why should I buy my goods electric vehicle through Turno?",
    answer:
      "Turno is a one-stop destination to buy all best-selling commercial electric vehicles available in the market. We help buyers to choose the best electric 3-wheeler vehicle for their business along with easy financing and assured resale.",
  },
  {
    id: 2,
    question: "Why should I switch from ICE to EV?",
    answer:
      "Switching from ICE to EV brings numerous benefits such as low running cost, low maintenance cost, government subsidies, tax exemption, resale value up to ₹1.5L (only with Turno), etc.",
  },
  {
    id: 3,
    question: "What is TCO? How does it impact my pocket?",
    answer:
      "Total Cost of Ownership (TCO) is the overall cost of owning a vehicle over a set time. To calculate TCO, add up the initial price, fuel, maintenance, and other expenses, then subtract the vehicle's resale value after that period. This gives you the true cost of owning the vehicle, which is called TCO. Calculating TCO before purchasing any vehicle is crucial because vehicles with a low ex-showroom price may ultimately have a high TCO, resulting in non-profitable purchases.",
  },
  {
    id: 4,
    question:
      "What are the popular brands of electric goods vehicles that Turno offers?",
    answer:
      "Turno offers a wide range of electric commercial vehicles from popular brands like Mahindra, Piaggio, Greaves, Altigreen, Euler, Etrio, OSM, and TATA.",
  },
  {
    id: 5,
    question:
      "How will I find the battery electric vehicle that suits my business?",
    answer:
      "In order to find the EV that suits your business, you should consider the desired load capacity, range, and budget. You can also contact Turno EV experts to help you find the best vehicle for your business.",
  },
  {
    id: 6,
    question: "Can I take a test drive of electric vehicles at Turno?",
    answer:
      "Yes, you can take a test drive of any EV of your choice. You can also opt for a doorstep test drive.",
  },
  {
    id: 7,
    question: "What is the price of Turno 3-wheeler EV?",
    answer:
      "The price of Turno 3-wheeler ranges from ₹3.9 lakhs to ₹4.5 lakhs.",
  },
  {
    id: 8,
    question: "What is the Turno warranty on an electric vehicle?",
    answer:
      "We provide 3 years of warranty on the electric vehicle battery. Also, if you wish to resell your vehicle to Turno, we provide a guaranteed resale value of up to ₹1.5 lakh or 40% of the ex-showroom price, whichever is lower, after 3 years.",
  },
  {
    id: 9,
    question:
      "Will Turno help me get a Government subsidy on electric cargo vehicles?",
    answer:
      "Absolutely! The quotation from Turno includes subsidies and registration charges for EVs. We also provide assistance in documentation to avail of the electric vehicle subsidy.",
  },
  {
    id: 10,
    question:
      "I don’t know my credit score. Can I still get financing for my goods electric vehicle?",
    answer:
      "At Turno, we provide assured on-road financing for electric vehicles. We also provide instant credit eligibility checks. To know more about EV financing, kindly contact Turno EV experts today at 08 10550 2233.",
  },
];

export const marketingfaqData = [
  {
    id: 2,
    question: "Can I take a test drive of electric vehicles at Turno?",
    answer:
      "Yes, you can take a test drive of any electric commercial three-wheeler of your choice. You can also opt for a doorstep test drive.",
  },
  {
    id: 3,
    question: "What is the Turno warranty on an electric vehicle?",
    answer:
      "We provide 3 years of warranty on the electric vehicle battery. Also, if you wish to resell your vehicle to Turno, we provide a guaranteed resale value of up to ₹1.5 lakh or 40% of the ex-showroom price, whichever is lower, after 3 years.",
  },
  {
    id: 4,
    question: "What is the Electric Loading Vehicle Price at Turno?",
    answer: "Electric goods auto price ranges from ₹3.9 lakhs to ₹4.5 lakhs.",
  },
  {
    id: 1,
    question:
      "What is Turno.club and why should I buy my goods electric vehicle through Turno?",
    answer:
      "Turno is a one-stop destination to buy all best-selling commercial electric vehicles available in the market. We help buyers to choose the best electric 3-wheeler vehicle for their business along with easy financing and assured resale.",
  },
  {
    id: 5,
    question: "Why should I switch from ICE to EV?",
    answer:
      "Switching from ICE to EV brings numerous benefits such as low running cost, low maintenance cost, government subsidies, tax exemption, resale value up to ₹1.5L (only with Turno), etc.",
  },
  {
    id: 6,
    question:
      "What are the popular brands of commercial three-wheeler vehicles that Turno offers?",
    answer:
      "Turno offers a wide range of electric commercial vehicles from popular brands like Mahindra, Piaggio, Greaves, Altigreen, Euler, Etrio, OSM, and TATA.",
  },
  {
    id: 7,
    question:
      "How will I find the battery powered delivery vehicle that suits my business?",
    answer:
      "In order to find the EV that suits your business, you should consider the desired load capacity, range, and budget. You can also contact Turno EV experts to help you find the best vehicle for your business.",
  },
  {
    id: 8,
    question:
      "Will Turno help me get a Government subsidy on electric loading vehicles?",
    answer:
      "Absolutely! The quotation from Turno includes subsidies and registration charges for EVs. We also provide assistance in documentation to avail of the electric vehicle subsidy.",
  },
  {
    id: 9,
    question:
      "I don’t know my credit score. Can I still get financing for my goods electric vehicle?",
    answer:
      "At Turno, we provide assured on-road financing for electric vehicles. We also provide instant credit eligibility checks. To know more about EV financing, kindly contact Turno EV experts today at 08 10550 2233.",
  },
];

export const commericalElectricVehicles = [
  {
    id: 1,
    question:
      "What are the popular brands of electric goods vehicles that Turno offers?",
    answer:
      "Turno offers a wide range of electric commercial vehicles from popular brands like Mahindra, Piaggio, Greaves, Altigreen, Euler, Etrio, and TATA.",
  },
  {
    id: 2,
    question: "What is the electric goods auto price in India?",
    answer:
      "Electric loading vehicle price in India ranges from ₹3.9 lakh to ₹4.5 lakh, depending on the brand, model, and features. The price of the vehicle also may differ depending on the region of the purchase. To know the exact amount you need to pay for any specific electric cargo vehicle in your region, please call us at 080 4748 2233.",
  },
  {
    id: 3,
    question: "What are the various uses of electric loading gadi in India?",
    answer:
      "In India, commercial electric autos are used for agile goods movement, intercity and intracity transportation, e-commerce, FMCG, parcel, water can distribution, milk can transportation etc.",
  },
  {
    id: 4,
    question: "What are the best electric cargo vehicle company in India?",
    answer:
      "The top cargo electric vehicle companies in India are Mahindra, Piaggio, Greaves, Altigreen, Euler, Etrio, and TATA. However, the best vehicle for any business depends on the required load capacity and range. To find the best vehicle for your business, please call with EV experts at 080 4748 2233.",
  },
  {
    id: 5,
    question:
      "What is the maximum loading capacity of an electric loading vehicle?",
    answer:
      "The load capacity of an electric loading vehicle ranges from 500 kg to 1.2 tons.",
  },
  {
    id: 6,
    question: "What is the Kerb Weight of an electric loading vehicle?",
    answer:
      "The kerb weight is the vehicle’s weight without people or extra cargo. The kerb weight varies for different vehicles and usually ranges between 450-600 kg.",
  },
  {
    id: 7,
    question: "How far can electric vehicles travel on a single charge?",
    answer:
      "Goods electric vehicles can travel up to 130 km on a single charge. However, the range of electric auto loading vehicles may differ from brand to brand and the load you are carrying.",
  },
  {
    id: 8,
    question:
      "Can I take a test drive of an electric commercial vehicle before purchasing it?",
    answer:
      "Yes, you can take a test drive of an electric commercial vehicle before purchasing it. With Turno, you can opt for a free home test drive or take a test drive at our showroom.",
  },
  {
    id: 9,
    question: "What are the advantages of electric goods vehicles?",
    answer:
      "Electric goods vehicles are much cheaper to operate when compared with similar diesel/CNG vehicles. Besides, it produces zero emissions, no noise pollution, and has better acceleration. Loading battery rickshaw are an excellent option for congested and busy roads.",
  },
  {
    id: 10,
    question:
      "Do I get power steering in electric three-wheeler goods vehicles?",
    answer:
      "No, electric goods vehicles do not have power steering, they come with handlebar steering.",
  },
  {
    id: 11,
    question: "What type of battery is used in electric cargo vehicles?",
    answer:
      "Most of today's electric loading vehicles use lithium-ion batteries. These batteries are best for EVs and they have high energy storage, low self-discharge, fast charging, water and dust resistance, etc.",
  },
  {
    id: 12,
    question: "How to buy an electric tempo?",
    answer:
      "You can buy electric tempos by visiting brand showrooms. However, if you want to find all top EV brands in one place, please visit Turno, we are a one-stop destination for best-selling top EV brands.",
  },
  {
    id: 13,
    question: "How long do e rickshaw loading auto batteries last?",
    answer:
      "Many factors affect the lifespan of an electric loading vehicle battery. On average, a well-maintained EV battery can retain around 70-80% of its original capacity after 8-10 years of use.",
  },
  {
    id: 14,
    question:
      "Are there any extended warranty options available for the Electric Load Vehicles?",
    answer:
      "Yes. Extended warranties are available on electric loading vehicles that provides additional coverage beyond the standard manufacturer warranty and can offer peace of mind by protecting against unexpected repairs and expenses.",
  },
  {
    id: 15,
    question: "Can Turno help me in servicing of my vehicle?",
    answer:
      "Yes, Turno offers servicing support for loading battery rickshaw to its customers in various ways such as booking servicing slots on a priority basis, video call assistance for non-critical issues etc. To know more, please contact us.",
  },
  {
    id: 16,
    question: "How can I contact Turno?",
    answer:
      "You can contact Turno from 8 am to 10 pm on all days to learn more or book EV goods carrier vehicle. Please call us at  080 4748 2233 or drop an email at sales@turno.club.",
  },
  {
    id: 17,
    question: "What is the cost of running battery auto for goods per km?",
    answer: "The cost of running load electric vehicle is nearly ₹0.9 per km.",
  },
  {
    id: 18,
    question: "Can I get a discount on loading auto rickshaw price?",
    answer:
      "Certainly, we run various offers and discounts on vehicles. However, the offers and  electric tempo price are subject to change depending on the region of purchase. Kindly contact us at  080 4748 2233 or drop an email at sales@turno.club to know more about it.",
  },
];

export const hindiCommericalElectricVehicles = [
  {
    id: 1,
    question:
      "Turno कौन-कौन से पॉपुलर ब्रांड्स के इलेक्ट्रिक लोडिंग गाड़ी ऑफर करता है? ",
    answer:
      "Turno कई सारे पॉपुलर ब्रांड्स जैसे महिंद्रा, पियाजियो, ग्रीव्स, अल्टीग्रीन, यूलेर, एट्रियो, बजाज और टाटा के इलेक्ट्रिक कमर्शियल गाड़ी ऑफर करता है।",
  },
  {
    id: 2,
    question: "इलेक्ट्रिक टेंपो की प्राइस क्या है? ",
    answer:
      "इंडिया में लोडिंग बैटरी रिक्शा की कीमत ₹3.9 लाख से ₹4.5 लाख के बीच होती है, जो ब्रांड, मॉडल और फीचर्स पर निर्भर करती है। गाड़ी की कीमत खरीद के राज्य  के अनुसार भी भिन्न हो सकती है। आपके राज्य में किसी लोडिंग ऑटो रिक्शा की कीमत की सही कीमत जानने के लिए, कृपया हमें 080 4748 2233 पर कॉल करें।",
  },
  {
    id: 3,
    question: "इंडिया में इलेक्ट्रिक लोडिंग गाड़ी के विभिन्न उपयोग क्या हैं?",
    answer:
      "इंडिया में कमर्शियल इलेक्ट्रिक ऑटो का उपयोग शहर के अंदर या बहार का यातायात, ई-कॉमर्स, FMCG, पार्सल, पानी के केन का वितरण, दूध के केन  आदि के लिए किया जाता है।",
  },
  {
    id: 4,
    question: "इंडिया में सबसे अच्छी इलेक्ट्रिक कार्गो गाड़ी कंपनी कौन सी है?",
    answer:
      "इंडिया में टॉप कार्गो इलेक्ट्रिक गाड़ी कंपनियाँ महिंद्रा, पियाजियो, ग्रीव्स, अल्टीग्रीन, यूलेर, एट्रियो, और टाटा हैं। हालांकि, किसी भी व्यवसाय के लिए सबसे अच्छा गाड़ी आवश्यक लोड क्षमता और रेंज पर निर्भर करता है। अपने व्यवसाय के लिए सबसे अच्छा गाड़ी खोजने के लिए, कृपया 080 4748 2233 पर EV एक्सपर्ट्स से बात करें।",
  },
  {
    id: 5,
    question: "इलेक्ट्रिक लोडिंग गाड़ी की अधिकतम लोड क्षमता क्या है?",
    answer:
      "इलेक्ट्रिक लोडिंग गाड़ी की लोड क्षमता 500 किलो से 1.2 टन तक होती है।",
  },
  {
    id: 6,
    question: "इलेक्ट्रिक गाड़ी एक बार चार्ज करने पर कितनी दूर तक जा सकते हैं?",
    answer:
      "लोडर इलेक्ट्रिक गाड़ी एक बार चार्ज करने पर 130 किमी तक जा सकते हैं।",
  },
  {
    id: 7,
    question:
      "क्या मैं इलेक्ट्रिक कमर्शियल गाड़ी खरीदने से पहले टेस्ट ड्राइव ले सकता हूं?",
    answer:
      "हां, आप इलेक्ट्रिक कमर्शियल गाड़ी खरीदने से पहले टेस्ट ड्राइव ले सकते हैं। Turno के साथ, आप घर पर मुफ्त टेस्ट ड्राइव ले सकते हैं या हमारे शोरूम पर भी टेस्ट ड्राइव ले सकते हैं।",
  },
  {
    id: 8,
    question: "इलेक्ट्रिक लोड गाड़ी के क्या क्या फायदे हैं?",
    answer:
      " इलेक्ट्रिक लोडिंग टेंपो चलाने में डीजल/CNG गाड़ी की तुलना में बहुत सस्ते होते हैं। इसके अलावा बैटरी गाड़ियां वायु और ध्वनि प्रदूषण नहीं करता और बेहतर एक्सेलरेशन देता है।तीन-पहिया इलेक्ट्रिक गाड़ी भीड़-भाड़ और व्यस्त सड़कों के लिए सबसे अच्छी गाड़ी हैं",
  },
  {
    id: 9,
    question:
      "क्या इलेक्ट्रिक तीन-पहिया कार्गो गाड़ीयों में पावर स्टीयरिंग होती है? ",
    answer:
      "नहीं, इलेक्ट्रिक लोड गाड़ियों में पावर स्टीयरिंग नहीं होता, इस पर हैंडलबार स्टीयरिंग होती है ।",
  },
  {
    id: 10,
    question:
      "इलेक्ट्रिक कार्गो  गाड़ियों में किस प्रकार की बैटरी का उपयोग होता है?",
    answer:
      "आजकल के ज्यादातर इलेक्ट्रिक कार्गो गाड़ियों में लिथियम-आयन बैटरी का उपयोग होता है। ये बैटरी EV के लिए सबसे अच्छी होती हैं और इनमें उच्च ऊर्जा भंडारण, कम स्व-निर्वहन, तेज चार्जिंग, पानी और धूल प्रतिरोध आदि होता है।",
  },
  {
    id: 11,
    question: "इलेक्ट्रिक टेम्पो कैसे खरीदें?",
    answer:
      "आप ब्रांड शोरूम में जाकर इलेक्ट्रिक टेम्पो खरीद सकते हैं। हालांकि, यदि आप एक ही स्थान पर सभी टॉप EV ब्रांड्स खोजना चाहते हैं, तो कृपया Turno पर आएं, हम बेस्ट-सेलिंग EV ब्रांड्स के लिए एक वन-स्टॉप डेस्टिनेशन हैं।",
  },
  {
    id: 12,
    question: "इलेक्ट्रिक ऑटो बैटरी कितने समय तक चलती है?",
    answer:
      "कई कारक इलेक्ट्रिक कार्गो गाड़ी बैटरी के लाइफ को प्रभावित करते हैं। औसतन, एक अच्छी तरह से रखरखाव वाली EV बैटरी 8-10 वर्षों के उपयोग के बाद अपनी मूल क्षमता का लगभग 70-80% बनाए रख सकती है।",
  },
  {
    id: 13,
    question:
      "क्या इलेक्ट्रिक लोड गाड़ियों के लिए एक्सटेंडेड वारंटी विकल्प उपलब्ध हैं?",
    answer:
      "हां, एक्सटेंडेड वारंटी मैन्युफैक्चरर के वारंटी से परे अतिरिक्त कवरेज प्रदान करती हैं और अचानक आने वाले मरम्मत और खर्चों से सुरक्षा प्रदान कर सकती हैं।",
  },
  {
    id: 14,
    question:
      "क्या Turno मेरी लोडिंग बैटरी रिक्शा की सर्विसिंग में मेरी मदद कर सकता है? ",
    answer:
      "हां, Turno अपने ग्राहकों को विभिन्न तरीकों से सर्विसिंग सहायता प्रदान करता है जैसे प्रायोरिटी के आधार पर सर्विसिंग स्लॉट बुक करना, गैर-क्रिटिकल मुद्दों के लिए वीडियो कॉल सहायता आदि। बैटरी वाला रिक्शा लोडिंग गाड़ी की मेंटेनेंस की अधिक जानकारी के लिए कृपया हमसे संपर्क करें।",
  },
  {
    id: 15,
    question: "Turno से कैसे संपर्क करें?",
    answer:
      "आप सभी दिनों में सुबह 8 बजे से रात 10 बजे तक ई रिक्शा लोडिंग गाड़ी की जानकारी के लिए Turno से संपर्क कर सकते हैं। कृपया हमें 080 4748 2233 पर कॉल करें या sales@turno.club पर ईमेल भेजें।",
  },
  {
    id: 16,
    question: "इलेक्ट्रिक ऑटो लोडिंग गाड़ी चलाने की लागत प्रति किमी क्या है?",
    answer: "लोडिग टैक्सी चलाने की लागत लगभग ₹0.9 प्रति किमी है।",
  },
  {
    id: 17,
    question: "क्या मुझे इलेक्ट्रिक टेंपो प्राइस पे कोई डिस्काउंट मिल सकता है?",
    answer:
      "बिलकुल, हम इलेक्ट्रिक लोडिंग टेंपो प्राइस पर कई ऑफर और छूट देते हैं। हालांकि, ऑफर और इलेक्ट्रिक टेम्पो की कीमत आपके क्षेत्र के अनुसार बदल सकती है। अधिक जानकारी के लिए कृपया हमें 080 4748 2233 पर कॉल करें या sales@turno.club पर ईमेल भेजें।",
  },
];

export const electricPassengerFaqs = [
  {
    id: 0,
    question:
      "How do I contact Turno?",
      answer: "You can contact Turno based on your region:",
      subPoints: [
        "Delhi/NCR: +918069808425 / +918048811021",
        "Lucknow:+918048811017 / +918045446788",
        "Kanpur: +918048811177",
        "DL/Noida: +918069808425"
      ],
  },
  {
    id: 1,
    question:
      "What is Turno.club and why should I buy my electric auto from Turno?",
    answer:
      "Turno is a marketplace where you can find the best passenger electric three-wheeler auto rickshaws available in the market. We help buyers choose the best electric vehicle, offering simple EV loans and guaranteed resale as well.",
  },
  {
    id: 2,
    question: "Does Turno have an exchange offer?",
    answer:
      "Yes, Turno offers an exchange program where you can sell your old vehicle and get a new commercial electric rickshaw. To learn more about this exchange offer, please contact us at 08047482233.",
  },
  {
    id: 3,
    question:
      "Does Turno provide loans for electric three-wheeler auto rickshaws?",
    answer:
      "Turno offers the best financing for electric autos with a down payment as low as ₹49,999 and low-interest rates. We provide loans with a low interest rate and  processing fee.",
  },
  {
    id: 4,
    question: "What is Turno's warranty on electric vehicles?",
    answer:
      "We provide a 3-year warranty on the battery of electric rickshaws. We offer a guaranteed resale value after 3 years, which is ₹1.5 lakh or 40% of the vehicle's price.",
  },
  {
    id: 5,
    question:
      "Will Turno help me get a government subsidy on electric auto rickshaws?",
    answer:
      "Absolutely! Turno's quotations include subsidies and registration charges for electric vehicles. We also assist with the documentation required to obtain the electric vehicle subsidy.",
  },
  {
    id: 6,
    question:
      "How long will it take to deliver my vehicle after I pay the booking amount?",
    answer:
      "Typically, it takes 1 day to deliver the e-rickshaw after the booking amount is deposited.",
  },
  {
    id: 7,
    question:
      "I don't know my credit score. Can I still get a loan for my e-rickshaw?",
    answer:
      "At Turno, we offer guaranteed on-road financing for electric three-wheeler auto rickshaws. We also provide instant credit eligibility checks. For more information about e rickshaw loans, please contact a Turno EV expert today at 080 4748 2233.",
  },
  {
    id: 8,
    question:
      "What is the longest and shortest loan term for my battery rickshaw?",
    answer:
      "With Turno, you can get a loan for e rickshaw for a term ranging from 12 to 48 months.",
  },
];

export const hindiElectricPassengerFaqs = [
  {
    id: 1,
    question:
      "Turno.club क्या है और मुझे अपना इलेक्ट्रिक ऑटो Turno से क्यों खरीदना चाहिए?",
    answer:
      "Turno एक मार्केटप्लेस है जहाँ आप बाजार में उपलब्ध सबसे अच्छे पैसेंजर इलेक्ट्रिक थ्री-व्हीलर ऑटो रिक्शा खरीद सकते हैं। हम खरीदारों को सबसे अच्छे इलेक्ट्रिक गाड़ी  चुनने में मदद करते हैं, सरल ईवी लोन और गारंटीड रीसेल भी प्रदान करते हैं।",
  },
  {
    id: 2,
    question: "क्या Turno के पास एक्सचेंज ऑफर है?",
    answer:
      "हाँ, Turno एक एक्सचेंज प्रोग्राम ऑफर करता है जहाँ आप अपनी पुरानी गाड़ी  बेचकर नयी कमर्शियल इलेक्ट्रिक रिक्शा डिस्काउंट पर खरीद सकते हैं। इस एक्सचेंज ऑफर के बारे में अधिक जानने के लिए कृपया हमसे 08047482233 पर संपर्क करें।",
  },
  {
    id: 3,
    question:
      "क्या Turno इलेक्ट्रिक थ्री-व्हीलर ऑटो रिक्शा के लिए लोन प्रदान करता है?",
    answer:
      "Turno इलेक्ट्रिक ऑटो के लिए सबसे अच्छा फाइनेंसिंग प्रदान करता है जिसमें डाउन पेमेंट सिर्फ ₹49,999 और कम ब्याज दरों के साथ होती है। हम कम ब्याज दर और प्रोसेसिंग फीस के साथ लोन प्रदान करते हैं।",
  },
  {
    id: 4,
    question: "क्या Turno इलेक्ट्रिक गाड़ीयों पर वारंटी देता है?",
    answer:
      "हम इलेक्ट्रिक रिक्शा की बैटरी पर 3 साल की वारंटी प्रदान करते हैं। हम 3 साल के बाद गारंटीड रीसेल वैल्यू भी देते हैं, जो कि ₹1.5 लाख या गाड़ी  की कीमत का 40% है।",
  },
  {
    id: 5,
    question:
      "क्या Turno मुझे इलेक्ट्रिक ऑटो रिक्शा पर सरकारी सब्सिडी प्राप्त करने में मदद करेगा?",
    answer:
      "बिल्कुल! Turno के कोटेशन में इलेक्ट्रिक गाड़ीयों के लिए सब्सिडी और रजिस्ट्रेशन फीस शामिल होते हैं। हम इलेक्ट्रिक गाड़ी  सब्सिडी प्राप्त करने के लिए आवश्यक डॉक्यूमेंटेशन में भी सहायता करते हैं।",
  },
  {
    id: 6,
    question:
      "बुकिंग राशि जमा करने के बाद मेरे गाड़ी  को डिलीवर होने में कितना समय लगेगा?",
    answer:
      "आमतौर पर, बुकिंग राशि जमा करने के बाद ई-रिक्शा को डिलीवर होने में 1 दिन का समय लगता है।",
  },
  {
    id: 7,
    question:
      "मुझे अपना क्रेडिट स्कोर नहीं पता। क्या मैं अभी भी अपने ई-रिक्शा के लिए लोन प्राप्त कर सकता हूँ?",
    answer:
      "Turno में, हम इलेक्ट्रिक थ्री-व्हीलर ऑटो रिक्शा के लिए गारंटीड ऑन-रोड फाइनेंसिंग प्रदान करते हैं। हम इंस्टेंट क्रेडिट एलिजिबिलिटी चेक भी प्रदान करते हैं। ई-रिक्शा लोन के बारे में अधिक जानकारी के लिए कृपया आज ही 080 4748 2233 पर Turno EV एक्सपर्ट से संपर्क करें।",
  },
  {
    id: 8,
    question:
      "क्या मुझे ई रिक्शा प्राइस पे कोई डिस्काउंट मिल सकता है?",
    answer:
      "बिलकुल, हम इलेक्ट्रिक ऑटो प्राइस पर कई ऑफर और छूट देते हैं। हालांकि, ऑफर और इलेक्ट्रिक थ्री व्हीलर की कीमत आपके खरीदने के राज्य के अनुसार बदल सकती है। अधिक जानकारी के लिए कृपया हमें 080 4748 2233 पर कॉल करें या sales@turno.club पर ईमेल भेजें।",
  },
];